import { ArrowRightIcon } from "@heroicons/react/20/solid"
import { useEffect, useState } from "react"

import { getProduct } from "@lib/swell/storefront-data-hooks/src/api/operations-swell"
import { getPrice } from "@lib/swell/storefront-data-hooks/src/utils/product"
import swell from "swell-js"

export function ProductList({ title, description, products, categories }) {
  const [productsList, setProductsList] = useState([])
  const [categoriesList, setCategoriesList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getProducts = async () => {
      setLoading(true)
      const promises = products
        .map((entry) => entry.product)
        .filter((handle) => typeof handle === "string")
        .map(async (handle) => {
          return await getProduct({ slug: handle })
        })
      const result = await Promise.all(promises)
      setProductsList(result)
      setLoading(false)
    }
    if (products) {
      getProducts()
    }
  }, [])

  useEffect(() => {
    const getCategories = async () => {
      setLoading(true)
      const promises = categories
        .map((entry) => entry.category)
        .filter((handle) => typeof handle === "string")
        .map(async (handle) => {
          return await swell.categories.get({ slug: handle })
        })
      const result = await Promise.all(promises)
      setCategoriesList(result)
      setLoading(false)
    }
    if (categories) {
      getCategories()
    }
  }, [])

  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-2xl px-4 sm:w-3/5 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="mx-auto text-center">
          <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
            {title}
          </h2>
          <p className="mt-4 text-lg font-medium text-pretty sm:text-xl/8">{description}</p>
        </div>

        {/* Products */}
        <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-4 sm:gap-y-8 lg:gap-x-6">
          {productsList?.map((product) => (
            <div
              key={product.id}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white drop-shadow-2xl"
            >
              <div className="aspect-h-2 aspect-w-3">
                <img
                  alt={product.name}
                  src={product.images[0].src}
                  className="w-full bg-gray-200 object-cover group-hover:opacity-75"
                />
              </div>
              <div className="flex flex-1 flex-col space-y-2 p-4">
                <h3 className="text-lg font-medium text-gray-900 sm:text-2xl">
                  <a href={`product/${product.slug}`}>
                    <span aria-hidden="true" className="absolute inset-0" />
                    {product.name}
                  </a>
                </h3>
                <div className="flex flex-1 flex-col justify-end">
                  <p className="text-md font-mono font-medium text-gray-900 sm:text-xl">
                    {getPrice(product.price, product.currency)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <hr className="my-8" />

        {/* Categories */}
        <div className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2 sm:gap-y-8 lg:gap-x-6">
          {categoriesList?.map((category) => (
            <div
              key={category.id}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white drop-shadow-2xl"
            >
              <img
                alt={category.results[0].name}
                src={category.results[0].images[0].file.url}
                className="w-full bg-gray-200 object-cover group-hover:opacity-75"
              />
              <div className="flex flex-1 flex-col space-y-2 p-4">
                <h3 className="text-lg font-medium text-gray-900 sm:text-2xl">
                  <a href={`collection/${category.results[0].slug}`}>
                    <span aria-hidden="true" className="absolute inset-0" />
                    {category.results[0].name}
                  </a>
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="mt-8 flex justify-center space-x-4">
          <a
            href="shop"
            className="inline-flex items-center gap-x-1.5 rounded-full bg-black px-4 py-2 text-lg font-semibold text-white sm:text-base"
          >
            Shop Kits & Parts <ArrowRightIcon className="h-4 w-4 stroke-white" />
          </a>
        </div>
      </div>
    </div>
  )
}
